import {
  AppConstant,
  VALIDATOR_PATTERNS,
} from 'src/app/helper/class/app-constant';
import {
  formBuilder,
  formBuilderData,
  tableColum,
} from 'src/app/helper/interface/response';
export const Image_Shown_Info: formBuilder[] = [
  {
    colName: 'profile_img_path',
    title: 'Profile',
    fileConfig: { fileType: 'IMAGE', filePath: '' },
    type: 'FILE',
  },
];
export const STAFF_LIST_TBL: tableColum[] = [
  { colName: 'id', title: '', isPrimary: true, visible: false },
  // {
  //   colName: 'profile_img_path',
  //   title: 'Profile',
  //   colType: 'IMAGE',
  // },
  {
    colName: 'name',
    title: 'Name',
    sort: true,
    filter: true,
  },
  {
    colName: 'staff_emp_id',
    title: 'Emp ID',
    sort: false,
    filter: true,
    colType: 'STAFF_ID',

  },
  {
    colName: 'schoolName',
    title: 'Institution',
    filter: true,
    sort: false,
  },
  {
    title: 'Gender',
    colName: 'gender',
    filter: true,
    sort: true,
    colType: 'DROPDOWN',
    filterCol: {
      type: 'DROPDOWN',
      data: [
        { label: 'Male', key: 1, color: 'primary' },
        { label: 'Female', key: 2, color: 'info' },
      ],
    },
  },
  {
    title: 'Mobile',
    colName: 'mobile_no',
    filter: true,
  },
  {
    title: 'Department',
    colName: 'department_fk_id',
    colType: 'DROPDOWN',
    filterCol: {
      type: 'DROPDOWN',
      apiName: 'department',
      selectPrimaryKey: 'id',
      selectKeyName: 'dName',
    },
    sort: true,
    filter: true,
  },
  {
    colName: 'do_join',
    title: 'Date of joining',
    sort: false,
    filter: true,
    colType: 'DATE',
    filterCol: {
      type: 'DATE',
      selectKeyName: 'do_join',
      yearNavigator: true,
      monthNavigator: true,
    },
  },
  {
    colName: 'updated_at',
    title: 'Last Update',
    sort: false,
    filter: true,
    colType: 'DATE',
    filterCol: {
      type: 'DATE',
      selectKeyName: 'updated_at',
      yearNavigator: true,
      monthNavigator: true,
    },
  },
  {
    colName: 'status',
    title: 'Status',
    sort: true,
    filter: true,
    colType: 'DROPDOWN',
    filterCol: {
      type: 'DROPDOWN',
      data: [{ asaName: 'Active', id: '1', color: 'success' },
      { asaName: 'Inactive', id: '0', color: 'danger' }
      ],
      selectKeyName: 'asaName',
      selectPrimaryKey: 'id',
    },
  },
];
export const DUPLICATE_STAFF_LIST_TBL: tableColum[] = [
  { colName: 'id', title: '', isPrimary: true, visible: false },

  {
    colName: 'name',
    title: 'Name',
    sort: true,
    filter: true,
  },
  {
    colName: 'staff_emp_id',
    title: 'Emp ID',
    sort: false,
    filter: true,
    colType: 'STAFF_ID',

  },
  {
    colName: 'schoolName',
    title: 'school',
    filter: true,
    sort: false,
  },

  {
    title: 'Mobile No',
    colName: 'mobile_no',
    filter: true,
  },
  {
    title: 'Email Id',
    colName: 'email_id',
    filter: true,
  },

];
export const DUPLICATE_STUDENT_LIST_TBL: tableColum[] = [
  { colName: 'id', title: '', isPrimary: true, visible: false },

  {
    colName: 'studentName',
    title: 'Name',
    sort: true,
    filter: true,
  },
  {
    colName: 'schoolName',
    title: 'Institution Name',
    sort: false,
    filter: true,

  },
  {
    colName: 'genderName',
    title: 'Gender',
    filter: true,
    sort: false,
  },

  {
    colName: 'course_name',
    title: 'Course Name',
    filter: true,
  }, {
    colName: 'aadhaar_no',
    title: 'Aadhar no',
    filter: true,
  },

];
export const STAFF_FORM: formBuilderData[] = [

  {
    colName: 'staff_emp_id',
    title: 'Staff Emp Id',
    groupStart: true,
    col_size: 6,
    event: { name: 'change', isCallback: true },
    readonly: false,
  },
  {
    colName: 'name',
    title: 'Name',
    col_size: '4',
    validator: [
      { name: 'required', error: 'Name should not be blank' },
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.TEXT,
        error:
          'Staff Name not Valid (Not allowed special character and space at end)',
      },
    ],
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'father_name',
    title: "Father's/ Husband's Name",
  },
  {
    colName: 'gender',
    title: 'Gender',
    type: 'select',
    data: AppConstant.GENDER,
    selectKeyName: 'genderName',
    selectPrimaryKey: 'id',
    event: { name: 'change', isCallback: true },
    validator: [{ name: 'required', error: 'Gender is required' }],
  },
  {
    colName: 'dob',
    title: 'Date of Birth ',
    // colType: 'DATE',
    type: 'DATE',
    monthNavigator: true,
    yearNavigator: true,
    dateFormat: 'dd/mm/yy',
    col_size: 6,
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
    validator: [{ name: 'required', error: ' required' }],
  },
  {
    colName: 'marital_status_fk_id',
    title: 'Marital Status',
    type: 'select',
    selectKeyName: 'marital_statusName',
    selectPrimaryKey: 'id',
    apiTblName: 'marital_status',
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'staff_category_fk_id',
    title: 'Staff Category',
    type: 'select',
    selectKeyName: 'staff_categoryName',
    selectPrimaryKey: 'id',
    apiTblName: 'staff_category',
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'email_id',
    title: 'Email Id',
    validator: [{ name: 'required', error: 'Email Required' }],
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'mobile_no',
    title: 'Mobile Number',
    validator: [{ name: 'required', error: 'Whatsapp Number Required' }],
  },
  {
    colName: 'alt_mobile_no',
    title: 'Alternate Mobile Number',
  },
  {
    colName: 'address',
    title: 'Address',
    type: 'TEXTAREA'
  },
  {
    groupTitle: 'Office',
    colName: 'school_fk_id',
    title: 'Institution',
    type: 'select',
    apiTblName: 'school',
    selectKeyName: 'schoolName',
    selectPrimaryKey: 'id',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'department_fk_id',
    title: 'Department',
    apiTblName: 'department',
    selectKeyName: 'dName',
    type: 'select'
  },
];
export const NEW_STAFF_FORM: formBuilderData[] = [

  {
    colName: 'staff_emp_id',
    title: 'Staff Emp Id',
    groupStart: true,
    col_size: 6,
    event: { name: 'change', isCallback: true },
    readonly: false,
  },
  {
    colName: 'title',
    title: 'Title',
    type: 'select',
    apiTblName: 'title',
    selectKeyName: 'titleName',
    selectPrimaryKey: 'id',
    col_size: '2',
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'name',
    title: 'Name',
    col_size: '4',
    validator: [
      { name: 'required', error: 'Name should not be blank' },
      {
        name: 'pattern',
        funValue: VALIDATOR_PATTERNS.TEXT,
        error:
          'Staff Name not Valid (Not allowed special character and space at end)',
      },
    ],
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'gender',
    title: 'Gender',
    type: 'select',
    data: AppConstant.GENDER,
    selectKeyName: 'genderName',
    selectPrimaryKey: 'id',
    event: { name: 'change', isCallback: true },
    validator: [{ name: 'required', error: 'Gender is required' }],
  },
  {
    colName: 'dob',
    title: 'Date of Birth ',
    colType: 'DATE',
    type: 'DATE',
    monthNavigator: true,
    yearNavigator: true,
    dateFormat: 'dd/mm/yy',
    col_size: 6,
    dateRange: AppConstant.DEFAULT_DATE_RANGE,
    validator: [{ name: 'required', error: ' required' }],
  },
  {
    colName: 'marital_status_fk_id',
    title: 'Marital Status',
    type: 'select',
    selectKeyName: 'marital_statusName',
    selectPrimaryKey: 'id',
    apiTblName: 'marital_status',
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'do_marriage',
    title: 'Date of Marriage',
    type: 'DATE',
    visible: false,
  },
  {
    colName: 'do_join',
    title: 'Date of Joining',
    type: 'DATE',

  },
  {
    colName: 'father_name',
    title: "Father's/ Husband's Name",
  },
  // {
  //   colName: 'select_student',
  //   title: 'Is Married',
  //   type: 'checkbox',
  //   defaultValue: 0,
  //   selectKeyName: 'name', selectPrimaryKey: 'id',
  //   data: [{ name: 'Yes', id: 1 }],
  //   visible: false,
  //   event: { isCallback: true, name: 'change' },
  //   col_size: '2'
  // },

  //   {
  //     colName: 'select_student',
  //     title: 'Is married ',
  //     type: 'checkbox',
  //     defaultValue: 0,
  //     selectKeyName: 'name', selectPrimaryKey: 'id',
  //     data: [{ name: 'Yes', id: 1 }],
  //     visible: false,
  //     event: { isCallback: true, name: 'change' },
  //   },
  //   {
  //     colName: 'student_fk_id',
  //     title: 'Marriage Date',
  //     colType: 'DATE',
  //     type: 'DATE',
  //     validator: [{ name: 'required' }],
  // },


  {
    colName: 'staff_category_fk_id',
    title: 'Staff Category',
    type: 'select',
    selectKeyName: 'staff_categoryName',
    selectPrimaryKey: 'id',
    apiTblName: 'staff_category',
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'email_id',
    title: 'Email Id',
    validator: [{ name: 'required', error: 'Email Required' },
    { name: 'pattern', funValue: VALIDATOR_PATTERNS.EMAIL }],
    event: { name: 'change', isCallback: true },
  },
  {
    colName: 'mobile_no',
    title: 'Mobile Number',
    validator: [{ name: 'required', error: 'Whatsapp Number Required' },
    { name: 'pattern', funValue: VALIDATOR_PATTERNS.MOBILE }],
  },
  {
    colName: 'alt_mobile_no',
    title: 'Alternate Mobile Number',
  },
  {
    colName: 'address',
    title: 'Address',
    type: 'TEXTAREA'
  },
  {
    groupTitle: 'Office',
    colName: 'school_fk_id',
    title: 'Institution',
    type: 'select',
    apiTblName: 'school',
    selectKeyName: 'schoolName',
    selectPrimaryKey: 'id',
    validator: [{ name: 'required' }],
  },
  {
    colName: 'department_fk_id',
    title: 'Department',
    apiTblName: 'department',
    selectKeyName: 'dName',
    type: 'select'
  },
];